export default "__VITE_ASSET__DckRax$z__"